(function () {
  const SWIPE_THRESHOLD = 40;

  function isRtl() {
    return document.documentElement.dir === 'rtl';
  }

  function wrapIndex(index, length) {
    return (index + length) % length;
  }

  function loadImage(src) {
    return new Promise((resolve) => {
      const image = new Image();
      image.onload = () => resolve(src);
      image.onerror = () => resolve(null);
      image.src = src;
    });
  }

  function thumbnailSource(item) {
    const thumb = item.querySelector('img');
    return thumb?.complete && thumb.naturalWidth ? thumb.currentSrc || thumb.src : '';
  }

  class ScLightbox extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('[data-lightbox-src]')];
      this.dialog = this.querySelector('dialog');
      if (!this.items.length || !this.dialog) return;
      this.image = this.dialog.querySelector('[data-lightbox-image]');
      this.counter = this.dialog.querySelector('[data-lightbox-counter]');
      this.bindTriggers();
      this.bindControls();
      this.bindSwipe();
    }

    bindTriggers() {
      this.items.forEach((item, index) => item.addEventListener('click', () => this.open(index)));
    }

    bindControls() {
      this.dialog.querySelector('[data-lightbox-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.querySelector('[data-lightbox-prev]').addEventListener('click', () => this.step(-1));
      this.dialog.querySelector('[data-lightbox-next]').addEventListener('click', () => this.step(1));
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog || event.target.hasAttribute('data-lightbox-stage')) this.dialog.close();
      });
      this.dialog.addEventListener('keydown', (event) => this.handleKey(event));
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('sc-lightbox-open');
        this.items[this.index]?.focus();
      });
    }

    bindSwipe() {
      let startX = null;
      this.dialog.addEventListener('pointerdown', (event) => { startX = event.clientX; });
      this.dialog.addEventListener('pointerup', (event) => {
        if (startX === null) return;
        const delta = event.clientX - startX;
        startX = null;
        if (Math.abs(delta) < SWIPE_THRESHOLD) return;
        const forward = isRtl() ? delta > 0 : delta < 0;
        this.step(forward ? 1 : -1);
      });
    }

    handleKey(event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      const towardsEnd = event.key === 'ArrowRight';
      this.step(towardsEnd !== isRtl() ? 1 : -1);
    }

    open(index) {
      this.show(index);
      document.documentElement.classList.add('sc-lightbox-open');
      this.dialog.showModal();
    }

    step(offset) {
      this.show(wrapIndex(this.index + offset, this.items.length));
    }

    show(index) {
      this.index = index;
      const item = this.items[index];
      const placeholder = thumbnailSource(item);
      this.image.src = placeholder || item.dataset.lightboxSrc;
      this.image.alt = item.querySelector('img')?.alt || '';
      this.counter.textContent = `${index + 1} / ${this.items.length}`;
      this.swapToFullSize(index);
      this.preloadNeighbours(index);
    }

    async swapToFullSize(index) {
      const src = await loadImage(this.items[index].dataset.lightboxSrc);
      if (src && this.index === index) this.image.src = src;
    }

    preloadNeighbours(index) {
      [1, -1].forEach((offset) => loadImage(this.items[wrapIndex(index + offset, this.items.length)].dataset.lightboxSrc));
    }
  }

  if (!customElements.get('sc-lightbox')) customElements.define('sc-lightbox', ScLightbox);
})();
